import { Mapper, MapperParams } from '@products/utils/mappers/type.mapper';
import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { ProductType } from '@types';
import {
  IndexDailyHoldingDTO,
  IndexPortfolioDTO,
  IndexProductDTO,
  IndexTopholdingDTO,
} from '../dto/top-constituent.dto.types';
import {
  IndexDailyHolding,
  IndexPortfolio,
  IndexProduct,
  IndexTopholding,
} from '../model/index-top-constituent';

export class IndexProductMapper extends Mapper<IndexProduct> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(indexesDTO: IndexProductDTO): IndexProduct {
    return {
      fundName: indexesDTO?.fundname,
      productType: indexesDTO?.producttype as ProductType,
      portfolio: indexesDTO?.portfolio
        ? this.createMapper(IndexPortfolioMapper).toDomain(
            indexesDTO?.portfolio
          )
        : null,
    };
  }
}

export class IndexPortfolioMapper extends Mapper<IndexPortfolio> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(indexesportfolioDTO: IndexPortfolioDTO): IndexPortfolio {
    return {
      topHoldings: indexesportfolioDTO?.topholdings?.length
        ? indexesportfolioDTO?.topholdings?.map((portflio) =>
            this.createMapper(IndexPortfolioHoldingMapper).toDomain(portflio)
          )
        : null,
      dailyholdings: indexesportfolioDTO?.dailyholdings?.length
        ? indexesportfolioDTO?.dailyholdings?.map((portflio) =>
            this.createMapper(IndexPortfolioDailyHoldingMapper).toDomain(
              portflio
            )
          )
        : null,
    };
  }
}

export class IndexPortfolioDailyHoldingMapper extends Mapper<IndexDailyHolding> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(dailyHoldingsDTO: IndexDailyHoldingDTO): IndexDailyHolding {
    return {
      asOfDate: dailyHoldingsDTO?.asofdate,
      asOfDateStd: dailyHoldingsDTO?.asofdatestd,
      issuerName: dailyHoldingsDTO?.secname,
      breakdownPercentage: dailyHoldingsDTO?.pctofnetassets,
      frequency: dailyHoldingsDTO?.frequency,
      countryCode: dailyHoldingsDTO?.cntrycode,
      isin: dailyHoldingsDTO?.isinsecnbr,
    };
  }
}

export class IndexPortfolioHoldingMapper extends Mapper<IndexTopholding> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(topHoldingsDTO: IndexTopholdingDTO): IndexTopholding {
    return {
      asOfDate: topHoldingsDTO?.asofdate,
      asOfDateStd: topHoldingsDTO?.asofdatestd,
      issuerName: topHoldingsDTO?.issuername,
      breakdownPercentage: topHoldingsDTO?.brkdwnpct,
      breakdownPercentageStd: topHoldingsDTO?.brkdwnpctstd,
      frequency: topHoldingsDTO?.frequency,
      countryCode: topHoldingsDTO?.cntrycode,
    };
  }
}
